function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useEffect, useState, useRef, forwardRef } from 'react';
import cn from 'classnames';
import { string, bool, shape, array } from 'prop-types';
import { LoggedInContext } from '@immediate_media/component-config';
import BrandedSection from '../BrandedSection';
import MainNav from '../MainNav';
import Image from '../../atoms/Image';
import PianoInlineTemplate from '../../atoms/PianoInlineTemplate';
import EyebrowNav from '../../molecules/EyebrowNav';
import SidebarNav from '../../molecules/SidebarNav';
import PopupContext from '../../context/PopupContext';
import AccountNav from '../../molecules/AccountNav';
import AuthDropDown from '../../molecules/AuthDropDown';
import { useIsDesktop } from '../../hooks';
import { filterSupportedEventListenerOptions, throttle } from '../../utils';
var popupKeys = {
  mainNav: 'main-navigation',
  search: 'search',
  account: 'account'
};
/**
 * A wrapper that lets us optionally use pure CSS stickiness.
 *
 * Safari has a bug where nested sticky elements are not repainted correctly
 * (see https://bugs.webkit.org/show_bug.cgi?id=106062). Hacks to force gpu
 * acceleration or repaints don't seem to work. The solution is to not have a
 * containing header element. However, when distributing this component
 * individually (e.g. via our static component setup) the component must have
 * a wrapper so that we have something to target for client-side hydration. So,
 * here we give the option of wrapping the header elements in a container, or
 * not. This essentially means we can have nice smooth CSS stickiness for our
 * new services but fallback to a prone to jankiness JS fixed positioning
 * toggle for our WordPress application. Once WP is no longer used for our
 * frontend this second option can go.
 */

var Wrapper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var wrap = _ref.wrap,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["wrap", "children"]);

  if (!wrap) {
    return children;
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, restProps), children);
});
/**
 * Toggle sticky behaviour when the eyebrow and main nav bar meet.
 */

var useStickyToggle = function useStickyToggle(_ref2) {
  var isDesktop = _ref2.isDesktop,
      fixedPositioning = _ref2.fixedPositioning,
      headerRef = _ref2.headerRef,
      eyebrowRef = _ref2.eyebrowRef,
      navRef = _ref2.navRef;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSticky = _useState2[0],
      setSticky = _useState2[1];
  /**
   * Handle the scoll event when using fixed positioning.
   *
   * Here we toggle the sticky behaviour based on scroll position and the
   * height of header elements minus the non-sticky branded section.
   *
   * On mobile and tablet the header is always sticky.
   */


  var fixedOnScroll = function fixedOnScroll() {
    if (!isDesktop) {
      setSticky(true);
      return;
    }

    var _headerRef$current$ge = headerRef.current.getBoundingClientRect(),
        headerHeight = _headerRef$current$ge.height,
        headerYPos = _headerRef$current$ge.y;

    var _eyebrowRef$current$g = eyebrowRef.current.getBoundingClientRect(),
        eyebrowHeight = _eyebrowRef$current$g.height;

    var _navRef$current$getBo = navRef.current.getBoundingClientRect(),
        mainNavHeight = _navRef$current$getBo.height;

    var heightToFix = isSticky ? headerHeight : headerHeight - eyebrowHeight - mainNavHeight; // In case the header isn't at the top of the screen (e.g. takeover ads)

    var yDiff = window.scrollY + headerYPos;
    setSticky(window.scrollY - yDiff > heightToFix);
  };
  /**
   * Handle the scroll event when not using fixed positioning.
   *
   * Here we toggle based on the position of the eyebrow and main nav. While
   * we use pure CSS for most of the sticky behaviour in this mode, we still
   * need a little JS to toggle the switch of the logo when they eyebrow joins
   * the main navigation bar.
   */


  var notFixedOnScroll = function notFixedOnScroll() {
    var _navRef$current$getBo2 = navRef.current.getBoundingClientRect(),
        navYPos = _navRef$current$getBo2.y;

    var _eyebrowRef$current$g2 = eyebrowRef.current.getBoundingClientRect(),
        eyebrowHeight = _eyebrowRef$current$g2.height,
        eyebrowTop = _eyebrowRef$current$g2.top;

    setSticky(navYPos - eyebrowTop <= eyebrowHeight);
  };

  useEffect(function () {
    var evtOpts = filterSupportedEventListenerOptions({
      passive: true
    });
    var onScroll = throttle(fixedPositioning ? fixedOnScroll : notFixedOnScroll, 100);
    onScroll(); // Fire on inital load in case already scrolled

    window.addEventListener('scroll', onScroll, evtOpts);
    return function () {
      window.removeEventListener('scroll', onScroll);
    };
  }, [isSticky, isDesktop]);
  return isSticky;
};
/**
 * Toggle behaviour around the active popup.
 */


var useActivePopup = function useActivePopup(_ref3) {
  var isDesktop = _ref3.isDesktop;
  var mainNavPopupKey = 'main-navigation';
  var accountNavPopupKey = 'account';

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      activePopup = _useState4[0],
      setActivePopup = _useState4[1]; // Prevent the page body from scrolling when the main mobile menu is open
  // Note that we target the body element directly, rather than use React Helmet
  // as this needs to work in environments where React Helmet is not available
  // (e.g. when served via the static component service).


  useEffect(function () {
    if (activePopup === mainNavPopupKey || activePopup === accountNavPopupKey) {
      document.body.classList.add('has-overlay');
    } else {
      document.body.classList.remove('has-overlay');
    }
  }, [activePopup]); // Clear any active popups on resize to desktop viewport

  useEffect(function () {
    var evtOpts = filterSupportedEventListenerOptions({
      passive: true
    });

    var clearActivePopups = function clearActivePopups() {
      if (activePopup && isDesktop) {
        setActivePopup(null);
      }
    };

    window.addEventListener('resize', clearActivePopups, evtOpts);
    return function () {
      window.removeEventListener('resize', clearActivePopups);
    };
  }, [activePopup, isDesktop]);
  return [activePopup, setActivePopup];
};
/**
 * Get the Whisk menu item.
 */


var getWhiskMenuItem = function getWhiskMenuItem(_ref4) {
  var trackingId = _ref4.trackingId,
      whiteLabel = _ref4.whiteLabel,
      text = _ref4.text;
  return {
    label: text,
    title: text,
    relativeUrl: '#',
    onClick: function onClick(evt) {
      evt.preventDefault();
      var whisk = window.whisk || {};
      whisk.queue = whisk.queue || [];
      whisk.queue.push(function () {
        whisk.shoppingList.viewList({
          trackingId: trackingId,
          whiteLabel: whiteLabel
        });
      });
    }
  };
};
/**
 * SiteHeader component.
 */


var SiteHeader = function SiteHeader(_ref5) {
  var brandedSectionLogo = _ref5.brandedSectionLogo,
      strapline = _ref5.strapline,
      search = _ref5.search,
      eyebrowMenuItems = _ref5.eyebrowMenuItems,
      eyebrowLogo = _ref5.eyebrowLogo,
      mobileLogo = _ref5.mobileLogo,
      logoUrl = _ref5.logoUrl,
      mainNavMenuItems = _ref5.mainNavMenuItems,
      profileDetails = _ref5.profileDetails,
      accountNavOptions = _ref5.accountNavOptions,
      className = _ref5.className,
      whiskSettings = _ref5.whiskSettings,
      fixedPositioning = _ref5.fixedPositioning,
      brandedSectionBackgroundImage = _ref5.brandedSectionBackgroundImage,
      mobileEyebrowBackgroundImage = _ref5.mobileEyebrowBackgroundImage;
  var eyebrowRef = useRef(null);
  var navRef = useRef(null);
  var headerRef = useRef(null);

  var eyebrowMenu = _toConsumableArray(eyebrowMenuItems);

  if (whiskSettings === null || whiskSettings === void 0 ? void 0 : whiskSettings.active) {
    eyebrowMenu.push(getWhiskMenuItem(whiskSettings));
  }

  var isDesktop = useIsDesktop();
  var isLoggedIn = useContext(LoggedInContext);

  var _useActivePopup = useActivePopup({
    isDesktop: isDesktop
  }),
      _useActivePopup2 = _slicedToArray(_useActivePopup, 2),
      activePopup = _useActivePopup2[0],
      setActivePopup = _useActivePopup2[1];

  var isSticky = useStickyToggle({
    isDesktop: isDesktop,
    fixedPositioning: fixedPositioning,
    headerRef: headerRef,
    eyebrowRef: eyebrowRef,
    navRef: navRef
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, {
    wrap: fixedPositioning,
    className: cn('site-header', className, isSticky && 'site-header--sticky'),
    ref: headerRef
  }, /*#__PURE__*/React.createElement(PopupContext.Provider, {
    value: {
      activePopup: activePopup,
      setActivePopup: setActivePopup,
      popupKeys: popupKeys
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: eyebrowRef,
    className: "site-header__eyebrow-nav hidden-print"
  }, /*#__PURE__*/React.createElement(EyebrowNav, {
    items: eyebrowMenu,
    logo: !isDesktop && mobileLogo ? mobileLogo : eyebrowLogo,
    logoUrl: logoUrl,
    swapContent: isSticky,
    accountNavOptions: accountNavOptions,
    mobileBackgroundImage: mobileEyebrowBackgroundImage // TODO: Enable avatar image when we have a way of pulling the data
    // through when using this component as a static header on WP
    // avatarImage={profileDetails.avatar}

  })), accountNavOptions && (isLoggedIn ? /*#__PURE__*/React.createElement("div", {
    className: "site-header__nav-section site-header__nav-section--right"
  }, /*#__PURE__*/React.createElement(SidebarNav, {
    accountNavOptions: accountNavOptions,
    profileDetails: profileDetails,
    left: false
  })) : /*#__PURE__*/React.createElement(AuthDropDown, {
    signInUrl: accountNavOptions.signInUrl,
    registerUrl: accountNavOptions.registerUrl
  })), /*#__PURE__*/React.createElement("div", {
    className: "site-header__brand"
  }, /*#__PURE__*/React.createElement(BrandedSection, {
    logo: brandedSectionLogo,
    strapline: strapline,
    search: search,
    logoUrl: logoUrl,
    backgroundImage: brandedSectionBackgroundImage
  })), /*#__PURE__*/React.createElement("div", {
    ref: navRef,
    className: "site-header__nav-section hidden-print"
  }, /*#__PURE__*/React.createElement(MainNav, {
    menuItems: mainNavMenuItems,
    mobileMenuItems: eyebrowMenu
  })))), /*#__PURE__*/React.createElement(PianoInlineTemplate, {
    isFixed: isSticky,
    position: "high"
  }));
};

SiteHeader.defaultProps = {
  className: null,
  brandedSectionLogo: null,
  strapline: null,
  eyebrowMenuItems: [],
  eyebrowLogo: null,
  mobileLogo: null,
  logoUrl: null,
  search: null,
  mainNavMenuItems: [],
  profileDetails: {},
  accountNavOptions: null,
  whiskSettings: {},
  fixedPositioning: false,
  brandedSectionBackgroundImage: null,
  mobileEyebrowBackgroundImage: null
};
SiteHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** The brand logo. */
  brandedSectionLogo: shape(Image.propTypes),

  /** Strapline under the brand logo.  */
  strapline: string,

  /** The eyebrow menu items. */
  eyebrowMenuItems: array,

  /** The logo to use in the eyebrow. */
  eyebrowLogo: shape(Image.propTypes),

  /** The logo to use in the eyebrow. */
  mobileLogo: shape(Image.propTypes),

  /** The URL to link to for the brand logos. */
  logoUrl: string,

  /** The search settings. */
  search: BrandedSection.propTypes.search,

  /** The main navigation menu items */
  mainNavMenuItems: MainNav.propTypes.menuItems,

  /** The sidebar drawer profile details */
  profileDetails: SidebarNav.propTypes.profileDetails,

  /** Account nav options. */
  accountNavOptions: shape(AccountNav.propTypes),

  /** Whisklink activation */
  whiskSettings: shape({
    active: bool,
    text: string,
    trackingId: string,
    whiteLabel: string
  }),

  /** Wrap the header in a containing div and use JavaScript, rather than CSS,
   * to enable the sticky behaviour. This should be considered a graceful
   * degradation for situations where we are forced to use it. */
  fixedPositioning: bool,

  /** The URL for the branded section background image */
  brandedSectionBackgroundImage: BrandedSection.propTypes.backgroundImage,

  /** The URL for the eyebrow background image to appear on mobile */
  mobileEyebrowBackgroundImage: EyebrowNav.propTypes.mobileBackgroundImage
} : {};
export default SiteHeader;